import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "tab-content rounded bg-white p-3 mb-4" };
const _hoisted_3 = {
    class: "tab-pane fade show active",
    id: "details-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "details-tab",
    tabindex: "0"
};
const _hoisted_4 = {
    key: 0,
    class: "badge text-bg-danger"
};
const _hoisted_5 = { class: "row mb-5" };
const _hoisted_6 = { class: "col-lg-6 col-12" };
const _hoisted_7 = { class: "table mb-3" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "border-5 border-start-0 border-end-0 border-top-0" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = ["href"];
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    key: 1,
    class: "fw-bold text-danger"
};
const _hoisted_18 = { key: 1 };
const _hoisted_19 = ["href"];
const _hoisted_20 = ["href"];
const _hoisted_21 = { class: "col-lg-6 col-12" };
const _hoisted_22 = { class: "form-floating mb-3" };
const _hoisted_23 = ["value"];
const _hoisted_24 = { class: "form-floating mb-3" };
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = { class: "form-floating mb-3" };
const _hoisted_27 = { class: "form-floating" };
const _hoisted_28 = { class: "form-floating mb-3" };
const _hoisted_29 = ["value"];
const _hoisted_30 = { class: "form-floating mb-3" };
const _hoisted_31 = ["value"];
const _hoisted_32 = { class: "form-floating mb-3" };
const _hoisted_33 = { class: "form-floating mb-3" };
const _hoisted_34 = { class: "table" };
const _hoisted_35 = { class: "align-middle" };
const _hoisted_36 = { class: "align-middle" };
const _hoisted_37 = { key: 1 };
const _hoisted_38 = { class: "align-middle" };
const _hoisted_39 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_40 = { key: 1 };
const _hoisted_41 = { class: "list-group list-group-flush" };
const _hoisted_42 = { class: "d-flex flex-wrap align-items-center" };
const _hoisted_43 = { class: "small fw-bold" };
const _hoisted_44 = {
    key: 0,
    class: "badge bg-danger ms-3"
};
const _hoisted_45 = {
    key: 1,
    class: "badge bg-danger ms-3"
};
const _hoisted_46 = {
    key: 0,
    class: "badge bg-success d-block my-1 ms-3"
};
const _hoisted_47 = {
    key: 1,
    class: "badge bg-success d-block my-1 ms-3"
};
const _hoisted_48 = { class: "align-middle" };
const _hoisted_49 = { class: "align-middle" };
const _hoisted_50 = { class: "align-middle" };
const _hoisted_51 = { class: "d-block fw-bold" };
const _hoisted_52 = {
    key: 0,
    class: "d-block text-danger"
};
const _hoisted_53 = { class: "row" };
const _hoisted_54 = { class: "col-12 col-lg-6 col-xl-4" };
const _hoisted_55 = { class: "table align-middle" };
const _hoisted_56 = { class: "d-block fw-bold" };
const _hoisted_57 = { class: "fw-bold" };
const _hoisted_58 = { class: "fw-bold" };
const _hoisted_59 = { class: "bg-light" };
const _hoisted_60 = { class: "fs-5 text-primary fw-bold" };
const _hoisted_61 = {
    class: "tab-pane fade",
    id: "delivery-date-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "delivery-date-tab",
    tabindex: "1"
};
const _hoisted_62 = { class: "row" };
const _hoisted_63 = { class: "col-12 col-lg-6" };
const _hoisted_64 = { class: "form-floating mb-3" };
const _hoisted_65 = {
    class: "tab-pane fade",
    id: "confirmation-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "confirmation-tab",
    tabindex: "1"
};
const _hoisted_66 = { class: "row" };
const _hoisted_67 = { class: "col-12 col-lg-6" };
const _hoisted_68 = { class: "form-floating mb-3" };
const _hoisted_69 = { class: "table table-hover align-middle" };
const _hoisted_70 = ["innerHTML"];
const _hoisted_71 = ["href"];
const _hoisted_72 = ["onClick"];
const _hoisted_73 = {
    class: "tab-pane fade",
    id: "payments-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "payments-tab",
    tabindex: "1"
};
const _hoisted_74 = { class: "row" };
const _hoisted_75 = { class: "col-12" };
const _hoisted_76 = { class: "form-floating mb-3" };
const _hoisted_77 = { class: "table table-hover" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link, router, useForm } from '@inertiajs/vue3';
import { onMounted } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        order: {
            type: Object,
            required: true
        },
        addresses: Object,
        orderStates: Object,
        orderPositions: Object,
        orderRequest: Object,
        confirmations: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const editOrderForm = useForm({
            orderStateId: props.order.orderStateId,
            vatId: props.order.vatId,
            email: props.order.email,
            phone: props.order.phone,
            adminNotes: props.order.adminNotes,
            approvedDeliveryDate: props.order.approvedDeliveryDate,
            invoiceAddressUuid: props.order.invoiceAddress.uuid,
            deliveryAddressUuid: props.order.deliveryAddress.uuid,
            paidAt: props.order.paidAt
        });
        const paymentVerificationForm = useForm({
            verificationId: null
        });
        const deliveryNotificationForm = useForm({
            notes: null
        });
        const orderConfirmationForm = useForm({
            notes: null
        });
        onMounted(() => {
        });
        function updateOrderDetails() {
            editOrderForm.transform((data) => ({
                order_state_id: data.orderStateId,
                vat_id: data.vatId,
                email: data.email,
                phone: data.phone,
                admin_notes: data.adminNotes,
                approved_delivery_date: data.approvedDeliveryDate,
                invoice_address_uuid: data.invoiceAddressUuid,
                delivery_address_uuid: data.deliveryAddressUuid,
                paid_at: data.paidAt
            })).submit('put', route('admin.orders.update', props.order.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function notifyCustomerAboutDelivery() {
            confirm.require({
                message: 'Der Kunde erhält hierdurch eine E-Mail mit der Benachrichtigung über das akzeptierte Lieferdatum.',
                header: 'Kundenbenachrichtigung zur Lieferung senden?',
                acceptLabel: 'Ja, versenden',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deliveryNotificationForm.transform((data) => ({
                        notes: data.notes
                    })).submit('post', route('admin.orders.deliveryDate.notify', props.order.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function cancelOrder() {
            confirm.require({
                message: 'Soll die Bestellung wirklich storniert werden?',
                header: 'Bestellung stornieren?',
                acceptLabel: 'Ja, stornieren',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.orders.cancel', props.order.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function removeOrder() {
            confirm.require({
                message: 'Soll die Bestellung wirklich gelöscht werden?',
                header: 'Bestellung löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.orders.destroy', props.order.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function verifyPayment() {
            paymentVerificationForm.transform((data) => ({
                verification_id: data.verificationId
            })).submit('post', route('admin.orders.payments.verify', props.order.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function createConfirmation() {
            confirm.require({
                message: 'Soll eine neue Auftragsbestätigung wirklich erstellt werden?',
                header: 'Neue Auftragsbestätigung erstellen?',
                acceptLabel: 'Ja, erstellen',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.post(route('admin.orders.confirmations.store', props.order.uuid), {
                        notes: orderConfirmationForm.notes
                    }, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function resendOrderConfirmation(confirmationUuid) {
            confirm.require({
                message: 'Soll die Auftragsbestätigung wirklich (erneut) versendet werden?',
                header: 'Auftragsbestätigung (erneut) versenden?',
                acceptLabel: 'Ja, versenden',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.post(route('admin.orders.confirmations.resend', confirmationUuid), {}, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function sendExternalApprovalMail() {
            confirm.require({
                message: 'Soll die Freigabe-Mail an den Kunden wirklich versendet werden? Der Kunde erhält hierdurch eine E-Mail mit der Bitte um Freigabe der Maßblätter.',
                header: 'Freigabe-Mail an Kunden versenden?',
                acceptLabel: 'Ja, versenden',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.post(route('admin.orders.externalApproval.sendMail', props.order.uuid), {}, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Bestellung" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Bestellung: " + _toDisplayString(props.order.uuid), 1),
                        _cache[64] || (_cache[64] = _createElementVNode("ul", {
                            class: "nav nav-underline mb-3",
                            role: "tablist"
                        }, [
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "details-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#details-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "details-tab-pane",
                                    "aria-selected": "true"
                                }, "Details")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "delivery-date-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#delivery-date-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "delivery-date-tab-pane",
                                    "aria-selected": "false"
                                }, "Lieferdatum")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "confirmation-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#confirmation-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "confirmation-tab-pane",
                                    "aria-selected": "false"
                                }, "Auftragsbestätigung")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "payments-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#payments-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "confirmation-tab-pane",
                                    "aria-selected": "false"
                                }, "Zahlung")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                    (props.order.payments.length == 0 && !props.order.paymentByBankTransfer)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Noch keine Zahlungseingänge vermerkt"))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("table", _hoisted_7, [
                                                _createElementVNode("tbody", null, [
                                                    _createElementVNode("tr", null, [
                                                        _cache[13] || (_cache[13] = _createElementVNode("th", null, "Status", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.status), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[14] || (_cache[14] = _createElementVNode("th", null, "Anfrage vom", -1)),
                                                        _createElementVNode("td", null, [
                                                            (props.orderRequest)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(formatDate)(props.orderRequest.createdAt, true)) + " Uhr", 1))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                                                        ])
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[15] || (_cache[15] = _createElementVNode("th", null, "Bestellung vom", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.createdAt, true)) + " Uhr", 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[16] || (_cache[16] = _createElementVNode("th", null, "Bezahlt", -1)),
                                                        _createElementVNode("td", null, [
                                                            (props.order.paidAt)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(formatDate)(props.order.paidAt, true)) + " Uhr", 1))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                                                        ])
                                                    ]),
                                                    (props.order.cancelledAt)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                                            _cache[17] || (_cache[17] = _createElementVNode("th", null, "Storniert", -1)),
                                                            _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.cancelledAt, true)) + " Uhr", 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("tr", _hoisted_13, [
                                                        _cache[18] || (_cache[18] = _createElementVNode("th", null, "Letzte Änderung", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.updatedAt, true)) + " Uhr", 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[19] || (_cache[19] = _createElementVNode("th", null, "Bestellnr.", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.orderId), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[20] || (_cache[20] = _createElementVNode("th", null, "Kunde", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.customer.customerNo) + " | " + _toDisplayString(props.order.customer.company) + " | " + _toDisplayString(props.order.customer.title) + " " + _toDisplayString(props.order.customer.firstname) + " " + _toDisplayString(props.order.customer.lastname), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[21] || (_cache[21] = _createElementVNode("th", null, "Rechnungsadresse", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.invoiceAddress.name), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[22] || (_cache[22] = _createElementVNode("th", null, "Lieferadresse", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.deliveryAddress.name), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[23] || (_cache[23] = _createElementVNode("th", null, "Umsatzsteuer-ID/Vat-ID", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.vatId), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[24] || (_cache[24] = _createElementVNode("th", null, "E-Mail", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.email), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[25] || (_cache[25] = _createElementVNode("th", null, "Telefon", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.phone), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[26] || (_cache[26] = _createElementVNode("th", null, "Bezahlart", -1)),
                                                        _createElementVNode("td", null, [
                                                            _createTextVNode(_toDisplayString(props.order.paymentOption) + " ", 1),
                                                            (props.order.paymentUrl)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                                    _createElementVNode("a", {
                                                                        href: props.order.paymentUrl,
                                                                        target: "_blank"
                                                                    }, "Zahlungslink/Beleg", 8, _hoisted_15)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[27] || (_cache[27] = _createElementVNode("th", null, "Gewünschtes Lieferdatum", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.requestDeliveryDate)), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[28] || (_cache[28] = _createElementVNode("th", null, "Kunden-Sprache", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.customer ? props.order.customer.lang : '-'), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[29] || (_cache[29] = _createElementVNode("th", null, "Anmerkung des Kunden", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(props.order.customerNotes), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[30] || (_cache[30] = _createElementVNode("th", null, "Zusätzliche Informationen", -1)),
                                                        (__props.order.advertistingPurpose)
                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_16, "Der Kunde stimmt zu, dass seine konfigurierten Produkte zu Werbezwecken verwendet werden dürfen."))
                                                            : _createCommentVNode("", true),
                                                        (!__props.order.advertistingPurpose)
                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_17, "Der Kunde stimmt NICHT zu, dass seine konfigurierten Produkte zu Werbezwecken verwendet werden dürfen."))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    (props.orderRequest)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                                            _cache[31] || (_cache[31] = _createElementVNode("th", null, "Verknüpft mit", -1)),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("a", {
                                                                    href: _ctx.route('admin.orderRequests.edit', props.orderRequest.uuid)
                                                                }, _toDisplayString(props.orderRequest.type), 9, _hoisted_19)
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("tr", null, [
                                                        _cache[33] || (_cache[33] = _createElementVNode("th", null, "Freigabe-URL", -1)),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("a", {
                                                                class: "d-block mb-3",
                                                                href: props.order.externalApprovalUrl,
                                                                target: "_blank"
                                                            }, _toDisplayString(props.order.externalApprovalUrl), 9, _hoisted_20),
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-primary d-inline-flex align-items-center",
                                                                onClick: _cache[0] || (_cache[0] = ($event) => (sendExternalApprovalMail()))
                                                            }, [...(_cache[32] || (_cache[32] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        height: "16",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-envelope",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" })
                                                                    ], -1),
                                                                    _createElementVNode("span", { class: "ms-2" }, "Mail an Kunden", -1)
                                                                ]))])
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("form", {
                                                onSubmit: _withModifiers(updateOrderDetails, ["prevent"])
                                            }, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "requestType",
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editOrderForm).orderStateId) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderStates, (status) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: status.id
                                                            }, _toDisplayString(status.name), 9, _hoisted_23));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(editOrderForm).orderStateId]
                                                    ]),
                                                    _cache[34] || (_cache[34] = _createElementVNode("label", { for: "requestType" }, "Status", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "vatId",
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editOrderForm).vatId) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editOrderForm).vatId]
                                                    ]),
                                                    _cache[35] || (_cache[35] = _createElementVNode("label", { for: "vatId" }, "Umsatzsteuer-ID/VAT-ID", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_25, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "email",
                                                        class: "form-control",
                                                        id: "email",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editOrderForm).email) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editOrderForm).email]
                                                    ]),
                                                    _cache[36] || (_cache[36] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_26, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "phone",
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editOrderForm).phone) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editOrderForm).phone]
                                                    ]),
                                                    _cache[37] || (_cache[37] = _createElementVNode("label", { for: "phone" }, "Telefon", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_27, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "date",
                                                        class: "form-control",
                                                        id: "approvedDeliveryDate",
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editOrderForm).approvedDeliveryDate) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editOrderForm).approvedDeliveryDate]
                                                    ]),
                                                    _cache[38] || (_cache[38] = _createElementVNode("label", { for: "approvedDeliveryDate" }, "Akzeptiertes Lieferdatum", -1))
                                                ]),
                                                _cache[43] || (_cache[43] = _createElementVNode("p", { class: "form-text mb-3" }, "Bitte informieren Sie den Kunden nach Festlegung des Lieferdatums.", -1)),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "invoiceAddress",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editOrderForm).invoiceAddressUuid) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.addresses, (address) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: address.uuid
                                                            }, _toDisplayString(address.name), 9, _hoisted_29));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(editOrderForm).invoiceAddressUuid]
                                                    ]),
                                                    _cache[39] || (_cache[39] = _createElementVNode("label", { for: "invoiceAddress" }, "Rechnungsadresse", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_30, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "deliveryAddressUuid",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editOrderForm).deliveryAddressUuid) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.addresses, (address) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: address.uuid
                                                            }, _toDisplayString(address.name), 9, _hoisted_31));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(editOrderForm).deliveryAddressUuid]
                                                    ]),
                                                    _cache[40] || (_cache[40] = _createElementVNode("label", { for: "deliveryAddressUuid" }, "Lieferadresse", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_32, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "date",
                                                        class: "form-control",
                                                        id: "paidAt",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editOrderForm).paidAt) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editOrderForm).paidAt]
                                                    ]),
                                                    _cache[41] || (_cache[41] = _createElementVNode("label", { for: "paidAt" }, "Bezahldatum", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_33, [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        class: "form-control",
                                                        id: "adminNotes",
                                                        style: { "height": "100px" },
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editOrderForm).adminNotes) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editOrderForm).adminNotes]
                                                    ]),
                                                    _cache[42] || (_cache[42] = _createElementVNode("label", { for: "adminNotes" }, "Admin-Anmerkungen", -1))
                                                ]),
                                                _cache[44] || (_cache[44] = _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "btn btn-success d-inline-flex align-items-center mb-4"
                                                }, [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ]),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                                ], -1))
                                            ], 32)
                                        ])
                                    ]),
                                    _cache[52] || (_cache[52] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Positionen", -1)),
                                    _createElementVNode("table", _hoisted_34, [
                                        _cache[45] || (_cache[45] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", { scope: "col" }, "#"),
                                                _createElementVNode("th", { scope: "col" }, "Produkt/Konfiguration"),
                                                _createElementVNode("th", { scope: "col" }, "Freigabe"),
                                                _createElementVNode("th", { scope: "col" }, "Einzelpreis"),
                                                _createElementVNode("th", { scope: "col" }, "Menge"),
                                                _createElementVNode("th", { scope: "col" }, "Gesamt")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderPositions, (position, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("td", _hoisted_35, _toDisplayString(index + 1), 1),
                                                    _createElementVNode("td", _hoisted_36, [
                                                        (position.editRoute)
                                                            ? (_openBlock(), _createBlock(_unref(Link), {
                                                                key: 0,
                                                                href: position.editRoute
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(position.productDetails), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["href"]))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(position.productDetails), 1))
                                                    ]),
                                                    _createElementVNode("td", _hoisted_38, [
                                                        (!position.hasPrintConfigurations)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Keine Freigabe erforderlich"))
                                                            : _createCommentVNode("", true),
                                                        (position.hasPrintConfigurations)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                _createElementVNode("ul", _hoisted_41, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.printConfigurations, (printConfiguration) => {
                                                                        return (_openBlock(), _createElementBlock("li", {
                                                                            key: printConfiguration.uuid,
                                                                            class: "list-group-item"
                                                                        }, [
                                                                            _createElementVNode("div", _hoisted_42, [
                                                                                _createElementVNode("span", _hoisted_43, _toDisplayString(printConfiguration.type), 1),
                                                                                (!printConfiguration.hasDimensionSheet)
                                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Maßblatt fehlt"))
                                                                                    : _createCommentVNode("", true),
                                                                                (printConfiguration.adminApprovedAt == null && printConfiguration.customerApprovedAt == null)
                                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Warten auf Freigabe"))
                                                                                    : _createCommentVNode("", true),
                                                                                _createElementVNode("div", null, [
                                                                                    (printConfiguration.adminApprovedAt)
                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Admin-Freigabe: " + _toDisplayString(_unref(formatDate)(printConfiguration.adminApprovedAt, true)) + " Uhr", 1))
                                                                                        : _createCommentVNode("", true),
                                                                                    (printConfiguration.customerApprovedAt)
                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Kunden-Freigabe: " + _toDisplayString(_unref(formatDate)(printConfiguration.customerApprovedAt, true)) + " Uhr", 1))
                                                                                        : _createCommentVNode("", true)
                                                                                ])
                                                                            ])
                                                                        ]));
                                                                    }), 128))
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(formatCurrency)(position.singlePrice)), 1),
                                                    _createElementVNode("td", _hoisted_49, _toDisplayString(position.amount), 1),
                                                    _createElementVNode("td", _hoisted_50, [
                                                        _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(formatCurrency)(position.totalPrice)), 1),
                                                        (position.originTotalPrice)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                                                _createElementVNode("del", null, _toDisplayString(_unref(formatCurrency)(position.originTotalPrice)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]));
                                            }), 128))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("table", _hoisted_55, [
                                                _createElementVNode("tbody", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("td", null, [
                                                            _createTextVNode("Versand (" + _toDisplayString(__props.order.deliveryType.name) + ") ", 1),
                                                            _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                                                            _createTextVNode(_toDisplayString((__props.order.totalWeight / 1000).toFixed(2)) + " kg nach " + _toDisplayString(__props.order.deliveryType.countryName), 1)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(formatCurrency)(__props.order.deliveryPrice)), 1),
                                                            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "d-block small" }, "exkl. MwSt.", -1))
                                                        ])
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[48] || (_cache[48] = _createElementVNode("th", null, "Gesamtsumme ohne MwSt.", -1)),
                                                        _createElementVNode("td", _hoisted_57, _toDisplayString(_unref(formatCurrency)(__props.order.totalPrice)), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("td", null, "zzgl. " + _toDisplayString(__props.order.taxRate) + " % MwSt.", 1),
                                                        _createElementVNode("td", _hoisted_58, _toDisplayString(_unref(formatCurrency)(__props.order.tax)), 1)
                                                    ]),
                                                    _createElementVNode("tr", _hoisted_59, [
                                                        _cache[49] || (_cache[49] = _createElementVNode("th", { class: "fs-5 text-primary" }, "Gesamtsumme inkl. MwSt.", -1)),
                                                        _createElementVNode("td", _hoisted_60, _toDisplayString(_unref(formatCurrency)(__props.order.totalPriceInclTax)), 1)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4 me-3",
                                        onClick: cancelOrder
                                    }, [...(_cache[50] || (_cache[50] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Bestellung stornieren", -1)
                                        ]))]),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: removeOrder
                                    }, [...(_cache[51] || (_cache[51] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Bestellung löschen", -1)
                                        ]))])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(notifyCustomerAboutDelivery, ["prevent"])
                                        }, [
                                            _createElementVNode("p", null, [
                                                _cache[53] || (_cache[53] = _createTextVNode("Akzeptiertes Lieferdatum: ", -1)),
                                                _createElementVNode("strong", null, _toDisplayString(_unref(formatDate)(props.order.approvedDeliveryDate)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_64, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "deliveryNotificationNotes",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(deliveryNotificationForm).notes) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(deliveryNotificationForm).notes]
                                                ]),
                                                _cache[54] || (_cache[54] = _createElementVNode("label", { for: "deliveryNotificationNotes" }, "Anmerkungen", -1))
                                            ]),
                                            _cache[55] || (_cache[55] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-primary text-white d-inline-flex align-items-center mb-3"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-envelope",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Bestätigung an Kunden senden")
                                            ], -1))
                                        ], 32)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("div", _hoisted_67, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(createConfirmation, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_68, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "confirmationNotes",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(orderConfirmationForm).notes) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(orderConfirmationForm).notes]
                                                ]),
                                                _cache[56] || (_cache[56] = _createElementVNode("label", { for: "confirmationNotes" }, "Anmerkungen (in der Auftragsbestätigung ersichtlich)", -1))
                                            ]),
                                            _cache[57] || (_cache[57] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-primary text-white d-inline-flex align-items-center mb-3"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-plus-lg",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "fill-rule": "evenodd",
                                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                                    })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Neue Auftragsbestätigung erstellen")
                                            ], -1))
                                        ], 32),
                                        _createElementVNode("table", _hoisted_69, [
                                            _cache[60] || (_cache[60] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", { scope: "col" }, "Belegdatum"),
                                                    _createElementVNode("th", { scope: "col" }, "Belegnummer"),
                                                    _createElementVNode("th", { scope: "col" }, "Anmerkung für den Kunden"),
                                                    _createElementVNode("th", { scope: "col" }, "Download"),
                                                    _createElementVNode("th", { scope: "col" }, "(Erneut) zusenden?")
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.confirmations, (confirmation) => {
                                                    return (_openBlock(), _createElementBlock("tr", null, [
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(confirmation.createdAt, true)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(confirmation.referenceNo), 1),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("small", {
                                                                innerHTML: confirmation.notes
                                                            }, null, 8, _hoisted_70)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("a", {
                                                                href: confirmation.downloadUrl
                                                            }, [...(_cache[58] || (_cache[58] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        height: "24",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-file-earmark-pdf",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" }),
                                                                        _createElementVNode("path", { d: "M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" })
                                                                    ], -1)
                                                                ]))], 8, _hoisted_71)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("button", {
                                                                class: "btn btn-primary text-white d-inline-flex align-items-center",
                                                                onClick: ($event) => (resendOrderConfirmation(confirmation.uuid))
                                                            }, [...(_cache[59] || (_cache[59] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        width: "16",
                                                                        height: "16",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-envelope",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" })
                                                                    ], -1)
                                                                ]))], 8, _hoisted_72)
                                                        ])
                                                    ]));
                                                }), 256))
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(verifyPayment, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_76, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "verificationId",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(paymentVerificationForm).verificationId) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(paymentVerificationForm).verificationId]
                                                ]),
                                                _cache[61] || (_cache[61] = _createElementVNode("label", { for: "verificationId" }, "Zahlungs-ID", -1))
                                            ]),
                                            _cache[62] || (_cache[62] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-primary text-white d-inline-flex align-items-center mb-3"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Zahlung verifizieren")
                                            ], -1))
                                        ], 32),
                                        _createElementVNode("table", _hoisted_77, [
                                            _cache[63] || (_cache[63] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", { scope: "col" }, "Status"),
                                                    _createElementVNode("th", { scope: "col" }, "Session-ID"),
                                                    _createElementVNode("th", { scope: "col" }, "Zahlungs-ID"),
                                                    _createElementVNode("th", { scope: "col" }, "Erwarteter Betrag (Netto)"),
                                                    _createElementVNode("th", { scope: "col" }, "Steuer"),
                                                    _createElementVNode("th", { scope: "col" }, "Bezahlter Betrag (Brutto)"),
                                                    _createElementVNode("th", { scope: "col" }, "Rabatt"),
                                                    _createElementVNode("th", { scope: "col" }, "Kommentar"),
                                                    _createElementVNode("th", { scope: "col" }, "Erstellt am")
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.order.payments, (payment) => {
                                                    return (_openBlock(), _createElementBlock("tr", null, [
                                                        _createElementVNode("th", null, _toDisplayString(payment.status), 1),
                                                        _createElementVNode("td", null, _toDisplayString(payment.sessionId), 1),
                                                        _createElementVNode("td", null, _toDisplayString(payment.paymentId), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(payment.estimatedAmount)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(payment.paidAmount - payment.estimatedAmount + payment.discountAmount)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(payment.paidAmount)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(payment.discountAmount)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(payment.comment), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(payment.createdAt, true)), 1)
                                                    ]));
                                                }), 256))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
